import interior from "../assets/phaser-grim-treasury/interior.webp";
import relic from "../assets/phaser-grim-treasury/relic.webp";
import hourglass from "../assets/phaser-grim-treasury/hourglass.png";

export const TREASURY_ART = { interior, relic, hourglass, width: 960, height: 1705, pedestalY: .594 } as const;
